module.exports = __webpack_public_path__ + "static/img/1065.3fa7a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1065.jpg
// module id = 247
// module chunks = 0